import { PinnedMessage } from '@wui/im'

export const sortPinnedNewestFirst = (events: PinnedMessage[]) => {
  return [...events].sort((left, right) => (right.timestamp ?? 0) - (left.timestamp ?? 0))
}

export const sortPinnedOldestFirst = (events: PinnedMessage[]) => {
  return [...events].sort((left, right) => (left.timestamp ?? 0) - (right.timestamp ?? 0))
}
